import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UUID from 'uuid'

class HtmlRenderer extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<div key={ UUID.v4() }>
				{ this.props.value }
			</div>
		)
	}
}

HtmlRenderer.propTypes = {
	value: PropTypes.object
}

HtmlRenderer.defaultProps = {
	value: ''
}

export default HtmlRenderer



// WEBPACK FOOTER //
// ./src/components/dataTable/AgGrid/HtmlRenderer.js